(function(){
  function ready(fn){ if(document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(function(){
    var revealEls = Array.prototype.slice.call(document.querySelectorAll('.reveal'));
    if('IntersectionObserver' in window && revealEls.length){
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          if(entry.isIntersecting){
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      }, {threshold:0.12, rootMargin:'0px 0px -40px 0px'});
      revealEls.forEach(function(el){ io.observe(el); });
    } else {
      revealEls.forEach(function(el){ el.classList.add('is-visible'); });
    }

    function submitPrimaryProductForm(trigger){
      var form = document.getElementById('AddToCartForm');
      var btn = document.getElementById('AddToCart');
      if(!form || !btn) return false;
      if(btn.disabled) return false;

      if(trigger){
        trigger.classList.add('is-loading');
        trigger.setAttribute('aria-busy', 'true');
        if(!trigger.hasAttribute('data-original-label')){
          trigger.setAttribute('data-original-label', trigger.textContent);
        }
        trigger.textContent = 'AGREGANDO...';
        window.setTimeout(function(){
          trigger.classList.remove('is-loading');
          trigger.removeAttribute('aria-busy');
          trigger.textContent = trigger.getAttribute('data-original-label') || 'AÑADIR AL CARRITO';
        }, 1800);
      }

      try {
        if(typeof form.requestSubmit === 'function'){
          form.requestSubmit(btn);
        } else {
          btn.click();
        }
        return true;
      } catch(err){
        try {
          btn.click();
          return true;
        } catch(err2) {
          return false;
        }
      }
    }

    document.addEventListener('click', function(e){
      var buy = e.target.closest('[data-nm-scroll-buy]');
      if(!buy) return;
      e.preventDefault();
      var submitted = submitPrimaryProductForm(buy);
      if(submitted) return;

      var btn = document.getElementById('AddToCart');
      if(btn){
        btn.scrollIntoView({behavior:'smooth', block:'center'});
        setTimeout(function(){ try{ btn.focus({preventScroll:true}); }catch(err){} }, 500);
      }
    });
  });
})();
